export default __webpack_public_path__ + "static/media/Avatar.dedc810e.png";